<app-page-layout [alertLoading]="alertLoading" [alertSucesso]="alertSucesso" [alertError]="alertError">
  <h1 class="titulo">Inclusão de endereço</h1>
  <p class="paragrafo mb-4">Inclua um endereço não cadastrado na base de dados</p>

  <app-endereco-form
    [formulario]="formulario"
    [consultaCep]="consultaCep"
    [mensagemErro]="mensagemErro">
  </app-endereco-form>

  <div class="d-flex container-fluid m-0 p-0 mt-5">
    <button class="botao-outline me-auto" id="btnFechar" (click)="voltarAbaEnderecos()">CANCELAR</button>
    <button class="botao px-5" id="btnSalvar" (click)="adicionarEmpresa()"
            [ngClass]="{ 'disabled': !formulario.valid }"
            [disabled]="!formulario.valid"
            data-bs-toggle="tooltip" data-placement="top"
            title="Preencha todos os campos obrigatórios.">SALVAR</button>
  </div>
</app-page-layout>
